import { Fragment, FunctionComponent, useState } from "react";
import { useLocale } from "stores/hooks/locale";
import { useParams } from "react-router";
import LoginView from "components/layout/login-view";
import Line from "components/layout/line";
import Signicat from "components/signicat";
import { showError } from "lib/notification";
import { userDoPostListSignicatSessions } from "services/signicat";
import { useTranslate } from "stores/hooks/translation";

const UserListLoginView: FunctionComponent = () => {
  const translate = useTranslate();
  const { listUuid } = useParams();
  const locale = useLocale();
  const [transition, toggleTransition] = useState(false);

  // wait until we have a list
  if (!listUuid) {
    return null;
  }

  const beginSignicat = async () => {
    if (!listUuid) {
      return;
    }

    try {
      const response = await userDoPostListSignicatSessions(listUuid, locale);
      const { authenticationUrl } = response;

      // start animation
      toggleTransition(true);

      setTimeout(() => (window.location.href = authenticationUrl), 500);
    } catch (err) {
      // login failed, show error
      showError("Login failed!");
    }
  };

  return (
    <LoginView title="Kirjautuminen" transition={transition}>
      <Fragment>
        <p>{translate("login_link_p1")}</p>
        <p>{translate("login_link_p2")}</p>
      </Fragment>
      <Line text={translate("login_begin_auth")} />
      <Signicat onClick={beginSignicat} />
    </LoginView>
  );
};

export default UserListLoginView;
